export const REDUCER_NAME = 'AddClientForm'

export enum requestTypes {
  add = 'add',
  update = 'edit',
  delete = 'delete',
}

export enum actionTypes {
  FETCH = 'AddClientForm/FETCH',
  FETCH_SUCCESS = 'AddClientForm/FETCH_SUCCESS',
  FETCH_FAILURE = 'AddClientForm/FETCH_FAILURE',
  SUBMIT = 'AddClientForm/SUBMIT',
  RESET = 'AddClientForm/RESET',
  UPDATE_BIRTHPLACE_SELECT = 'AddClientForm/UPDATE_BIRTHPLACE_SELECT',
  UPDATE_CITIES_LIST = 'AddClientForm/UPDATE_CITIES_LIST',
}

export enum countryToCityTypes {
  CountryID = 'CityID',
  Country2ID = 'City2ID',
  CountryBusID = 'CityBusID',
}

export const idCardNumbersCount = 9
export const individualIDCardNumbersCount = 11
export const businessClient = 3

export const emailFields = ['Email', 'Email1']

export const CONFIRM_MATRIX_WARNING = 'AddClientForm-confirmMatrixWarning'
export const CLIENT_VALIDATION_RESULTS_MODAL = 'AddClientForm-clientValidationResults'
export const CONFIRM_WHITELIST_WARNING = 'confirmWhitelistWarning'

export const FORM_NAME = 'AddClientForm'
